module.exports = __webpack_public_path__ + "img/lg_ring_g_l_1_0@2x.378325ec.png";